import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';

interface ModalProps {
  isOpen: boolean;
  setOpen: (a: any) => void;
  handleDelete?: () => void;
  handleAction?: () => void;
  question?: any;
  questionMark?: Boolean;
  objectType?: string; // e.g: offering; contact; forecast...
  name?: string;
  description?: string;
  logo?: any;
  loadingConfirm?: boolean;
}

export default function ConfirmDeleteModal({
  isOpen,
  setOpen,
  handleDelete = () => {},
  handleAction = () => {},
  question,
  questionMark = true,
  objectType = 'data', // e.g: offering; contact; forecast...
  name = '',
  description,
  logo,
  loadingConfirm
}: ModalProps) {
  const { t } = useTranslation();
  return (
    <Dialog onOpenChange={setOpen} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle icon="delete" className="flex items-center gap-4">
            {logo && <div className="w-auto">{logo}</div>}
            <div>
              {question ? question : `${t('r_u_sure_delete')} ${objectType} `}
              <span className="underline">{name}</span>
              {questionMark ? '?' : ''}
            </div>
          </DialogTitle>
          <DialogDescription>
            {description ? description : t('all_your_info_del')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            loading={loadingConfirm}
            onClick={() => {
              handleAction();
              handleDelete();
            }}
          >
            {t('yes_sure')}
          </Button>
          <Button
            variant="ghost"
            onClick={() => {
              setOpen(false);
            }}
          >
            {t('cancel')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
